import React from "react";
import SvgTProductDeutscheTelekomBrandLogo from "@/assets/icons/t_product/deutsche-telekom-brand-logo.svg";

export default function TProductDeutscheTelekomBrandLogo(props) {
  return <SvgTProductDeutscheTelekomBrandLogo {...props} />;
}
